var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCivilEngineeringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.027,
    height: 18,
    viewBox: "0 0 17.027 18",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "engineering_FILL1_wght500_GRAD200_opsz48",
    d: "M9.876,16.718A4.09,4.09,0,0,1,6.855,15.54,4,4,0,0,1,5.677,12.6H5.421A.551.551,0,0,1,5,12.416a.616.616,0,0,1-.166-.435A.585.585,0,0,1,5,11.571a.551.551,0,0,1,.422-.179h.256a3.6,3.6,0,0,1,.589-2.023A4.262,4.262,0,0,1,7.777,7.961V8.985a.392.392,0,0,0,.128.282.419.419,0,0,0,.307.128.46.46,0,0,0,.294-.115.364.364,0,0,0,.141-.294V7.628q.2-.026.563-.077A4.89,4.89,0,0,1,9.9,7.5a4.727,4.727,0,0,1,.666.051q.358.051.589.077V8.985a.4.4,0,0,0,.115.294.448.448,0,0,0,.615-.013.377.377,0,0,0,.141-.282V7.961A4.223,4.223,0,0,1,13.5,9.369a3.66,3.66,0,0,1,.576,2.023h.256a.551.551,0,0,1,.422.179.616.616,0,0,1,.166.435.523.523,0,0,1-.179.4.585.585,0,0,1-.41.166h-.256a4,4,0,0,1-1.191,2.97A4.1,4.1,0,0,1,9.876,16.718Zm0-1.972a2.138,2.138,0,0,0,1.6-.615,2.241,2.241,0,0,0,.6-1.639h-4.4a2.269,2.269,0,0,0,.589,1.639A2.129,2.129,0,0,0,9.876,14.746ZM1.35,25.5V22.709a2.809,2.809,0,0,1,.461-1.639,3.167,3.167,0,0,1,1.255-1.05,16.862,16.862,0,0,1,3.085-1.139,14.426,14.426,0,0,1,3.725-.448,14.415,14.415,0,0,1,3.674.435,17.389,17.389,0,0,1,3.137,1.152,3.208,3.208,0,0,1,1.229,1.05,2.809,2.809,0,0,1,.461,1.639V25.5Z",
    transform: "translate(-1.35 -7.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCivilEngineeringIcon);
export default __webpack_public_path__ + "static/media/civilEngineering_icon.daa7347dc04283a8bd908372782dce51.svg";
export { ForwardRef as ReactComponent };